export default "__VITE_ASSET__afc3a37e__"